export default __webpack_public_path__ + "img/wechat.6354302b.svg";